<template>
    <div class="wrapper" style="background-color:#fff;">

        <Sidebar />

        <div class="container container-fix" :style="{ 'margin-left': sidebarWidth }">
            <div class="top" style="height:60px;"></div>
            <h4 class="mb-6 font-semibold">How To Use Contractly</h4>
            <div class="bg-gray-100 flex flex-col p-4 rounded-xl " style="height: fit-content;">
                 
                <video ref="videoPlayer"
                   :src="require('../assets/videos/HowToUse.mp4')"
                   controls
                   style="width: 100%; height: auto; border-radius: 5px; border: 1px solid #ccc;"
                   @ended="onVideoEnd" @loadedmetadata="onVideoLoaded"></video>
            </div>
        </div>
    </div>

</template>
 
<script>
    import Sidebar from '../components/siderbar/SidebarComponent';
    import { sidebarWidth } from '../components/siderbar/state';

    export default {

        components: {
            Sidebar,
            
        },
        setup() {
            return { sidebarWidth }
        },
        data() {
             
           
        },
        mounted() {
       
            //this.$refs.videoPlayer.play();
        },
        methods: {
            onVideoLoaded() {
                this.$refs.videoPlayer.currentTime = 1;
            },
            onVideoEnd() {
                // Optionally handle the event when the video ends
                console.log("Video has ended");
            }
        }
    };



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @media (max-width: 600px) {
        
        .p-4{padding: 0px !important;}
    }
       
</style>

